import { storyblokEditable } from "@storyblok/react/rsc";

import { ListItem } from "@/components/layout/ListItem";
import type { ListItemIconName } from "@/components/icons";

import type { AssetStoryblok } from "@/component-types-sb";

type IconListItemStoryblok = {
  icon: ListItemIconName;
  custom_icon?: AssetStoryblok;
  text: string;
  _uid: string;
  component: "icon_list_item";
  [k: string]: any;
};

type IconListItemProps = {
  blok: IconListItemStoryblok;
};

const IconListItem = ({ blok }: IconListItemProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <ListItem icon={blok.icon} customIconUrl={blok.custom_icon?.filename}>{blok.text}</ListItem>
    </div>
  );
};

export default IconListItem;
